import DateFilterService from '../../../services/date-filter-service';
import OutcomeConversionService from '../../../services/outcome-conversion-service';
import MyBetEventModel from './mybet-event-model';
import MyBetCombinationModel from './mybet-combination-model';
/**
 * Calculate sum with possible t
 * @param {number|string} prev 
 * @param {number|string} next 
 */
const calcT = (prev, next) => {
  const prasedNext = parseFloat(next);
  const prasedPrev = parseFloat(prev);
  return prasedNext === next ? prasedPrev + prasedNext : `${prasedPrev + prasedNext}t`;
};
/**
 * Class for bet transactions
 */
export default class MyBetModel {
  /**
   * Class constructor method
   */
  constructor({
    BetSlipGroupID = 0,
    BetSlipGroupStatus = '',
    BetSlipGroupStatusID = 0,
    BetSlipGroupType = '',
    BetSlipTypeID = 1,
    Combinations = [],
    CreatedDateTime = '',
    // CreatedDateTimeString = null,
    // CreatedOn = '',
    Events = [],
    Identifier = '',
    Odds = '',
    PayOutTax = 0,
    PotWinnings = 0,
    Stake = 0,
    StakeTax = 0,
    TotalBonus = 0,
    Winnings = 0,
    TotalTax = 0,
    CashoutValue = 0,
    TimeOut = '',
    // negotiations
    TotalPossibleWinnings = '',
    TotalOdds = '',
    // isUTC = false,
    NegotiationMessage = '',
  }) {
    this.betSlipGroupID = BetSlipGroupID;
    this.betSlipGroupStatus = BetSlipGroupStatus;
    this.betSlipGroupStatusId = BetSlipGroupStatusID;
    this.betSlipGroupType = BetSlipGroupType;
    this.betSlipGroupTypeId = BetSlipTypeID;
    this.combinations = Combinations.map(model => new MyBetCombinationModel(model));
    /**
     * @type {string}
     */
    this.createdOn = DateFilterService.localDate(
      CreatedDateTime,
      'datetime',
      APP_SETTINGS.formatting.fullDateFormat,
      APP_SETTINGS.formatting.fullTimeFormat,
      true
    );
    this.timeOut = TimeOut;
    this.items = Events.map(model => new MyBetEventModel(model));
    this.identifier = Identifier;
    this.odds = Odds !== '' ? OutcomeConversionService.outcomeConverter(Odds) : OutcomeConversionService.outcomeConverter(TotalOdds);
    this.payOutTax = PayOutTax;
    this.potWinnings = PotWinnings !== 0 ? PotWinnings : TotalPossibleWinnings;
    this.stake = Stake;
    this.stakeTax = StakeTax;
    this.bonus = TotalBonus;
    this.winnings = Winnings;
    this.tax = TotalTax;
    this.cashoutValue = CashoutValue;
    this.negotiationMessage = NegotiationMessage;
    this.tick = 0;
    const { totalUnitStake, totalNumOfBets } = this.combinations.reduce((prev, next) => {
      let totals = {
        totalNumOfBets: prev.totalNumOfBets += next.numOfBets,
        totalUnitStake: calcT(prev.totalUnitStake, next.unitStake),
      };
      return totals;
    }, {
      totalUnitStake: 0,
      totalNumOfBets: 0,
    });
    this.totalNumOfBets = totalNumOfBets;
    this.unitStake = totalUnitStake;
  }
}
